// @flow

export const DISABLED: 'Disabled' = 'Disabled';
export const SNACKBAR: 'Snackbar' = 'Snackbar';
export const DIALOG: 'Dialog' = 'Dialog';
